import { Action } from '../../../shared/xs/actions';

export class LogoutAction implements Action {
  static readonly type = '[Auth] Logout';
}
